jQuery(document).ready(function($) {

  if ( $('.o-featured-project-cards')[0] ) {
    var tempSliderInit = 0;
    $(window).on('resize load', function () {
      if ($(this).width() <= 950) {
        if (!tempSliderInit) {
          $('.o-featured-project-cards .m-project-cards__list').slick({
            slidesToShow: 2,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 501,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }
        tempSliderInit = 1;
      } else {
        if (tempSliderInit) {
          $('.o-featured-project-cards .m-project-cards__list').slick('unslick');
        }
        tempSliderInit = 0;
      }
    });

    $(".o-featured-project-cards__arrow--left").click(function () {
      $(this).closest(".o-featured-project-cards").find('.m-project-cards__list').slick("slickPrev");
    });

    $(".o-featured-project-cards__arrow--right").click(function () {
      $(this).closest(".o-featured-project-cards").find('.m-project-cards__list').slick("slickNext");
    });
  }

});